<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 26 26"
    fill="currentColor"
  >
    <path
      d="M10.6332174,5.94562346 L6.0454323,3.23500086 C4.91913482,2.57423967 3.5,3.38517386 3.5,4.69167893 L3.5,21.3083211 C3.5,22.6148261 4.91913482,23.4257603 6.0454323,22.7649991 L10.6332174,20.0618852 L22.6470571,13.0037543 L10.6332174,5.94562346 Z"
    />
  </svg>
</template>
